<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item prop="oldPassword" label="旧密码">
            <el-input v-model="form.oldPassword" :show-password="true" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
            <el-input v-model="form.newPassword" :show-password="true" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword2" label="确定密码">
            <el-input v-model="form.newPassword2" :show-password="true" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
import md5 from "md5"

export default {
  data: function() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        newPassword2: ""
      },
      rules: {
        oldPassword: [{ required: true, message: "必填项", trigger: "change" }],
        newPassword: [
            { required: true, message: "必填项", trigger: "change" }
        ],
        newPassword2: [
            { required: true, message: "必填项", trigger: "change" },
            {
                validator: (rule, value, callback) => {
                    var equal = this.form.newPassword == this.form.newPassword2;
                    if(equal){
                        callback();
                    }else{
                        callback(new Error('密码不一致'));
                    }
                },
                message: '密码不一致',
                trigger: "change"
            }
        ]
      }
    };
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          const userNumber=this.$store.state.userNumber;
          let data = Object.assign({}, this.form);
        //  console.log(userNumber)
        //  console.log(userNumber['userNumber'])
          data["oldPassword"] = md5(userNumber['userNumber']+data["oldPassword"]+userNumber['userNumber']).toUpperCase();
          data["newPassword"] = md5(userNumber['userNumber']+data["newPassword"]+userNumber['userNumber']).toUpperCase();
          delete data['newPassword2'];

          onValid(data);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2d3a4b;

  & > div {
    width: 20%;
    height: 50%;

    & > h2 {
      text-align: center;
      color: #eeeeee;
    }

    & button {
      width: 100%;
    }
  }
}
</style>